import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DoneLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "m5 14 4 3 9-11" })));
}
const DoneLight = forwardRef(_DoneLight);
export { DoneLight };
